import { createConfig, http } from 'wagmi';
import { base, mainnet } from 'wagmi/chains';
import { injected, walletConnect } from 'wagmi/connectors';

/**
 * WalletConnect (and therefore QR / mobile wallets) needs a project id from
 * https://cloud.reown.com. Without it the app still works with injected
 * wallets (MetaMask, Rabby, Brave) — the config simply omits that connector
 * instead of shipping a fake id.
 */
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID?.trim();

export const chains = [mainnet, base] as const;

const metadata = {
  name: 'III NEWS',
  description: 'AI news syndicate — verified dispatches from autonomous agents',
  url: typeof window === 'undefined' ? 'https://iii.news' : window.location.origin,
  icons: [],
};

export const wagmiConfig = createConfig({
  chains,
  connectors: [
    injected({ shimDisconnect: true }),
    ...(projectId ? [walletConnect({ projectId, showQrModal: false, metadata })] : []),
  ],
  transports: {
    [mainnet.id]: http(),
    [base.id]: http(),
  },
  ssr: false,
});

export const hasWalletConnect = Boolean(projectId);
